export const PAGE_KEYS = {
  testStructure: "test-structure",
  onlinePaymentLogs: "online-payment-logs",
  jobSchedules: "job-schedules",
  integrationMonitor: "integration-monitor",
  quickQuizMaker: "quick-quiz-maker",
  overwriteTestTime: "overwrite-test-time",

  companiesList: "companies-list",
  companiesTypesAdmin: "companies-types-admin",
  companiesStagesAdmin: "companies-stages-admin",
  companiesHot: "companies-hot",

  iteachAclConfig: "iteach-acl-config",
  tenantPreferences: "tenant-preferences",
  errorHelp: "error-help",
  governanceConsole: "governance-console",
  analyticsHub: "analytics-hub",
  learningAnalytics: "learning-analytics",
  adminUsage: "admin-usage",
  mailboxConnections: "settings-mailbox",
  mailboxAdmin: "settings-mailbox-admin",
  paymentGatewayConfig: "settings-payment-gateway",
  credentialAdmin: "credential-admin",
  productCms: "product-cms",
  portletConfig: "portlet-config",
  portletGroup: "portlet-group",
  aiWorkspaceConfig: "ai-workspace-config",
  flipClassConfig: "flip-class-config",
  schedulingConfig: "scheduling-config",
  testCategorySettings: "test-category-settings",

  centreManagement: "centre-management",
  schoolManagement: "school-management",
  holidayManagement: "holiday-management",
  employeeManagement: "employee-management",
  classroomShiftManagement: "classroom-shift-management",
  timecraftInputManagement: "timecraft-input-management",
  courseYearProperties: "course-year-properties",
  courseManagement: "course-management",
  batchManagement: "batch-management",
  programManagement: "program-management",
  parentManagement: "parent-management",
  webformAdmin: "webform-admin",

  installmentStructure: "installment-structure",
  feeTemplates: "fee-templates",
  discountStructures: "discount-structures",
  financialReportsCollections: "financial-reports-collections",
  financialReportsDefaulters: "financial-reports-defaulters",
  nonConductedClasses: "non-conducted-classes",
  cumulativeTestReport: "cumulative-test-report",
  invoiceRuns: "invoice-runs",
  expenses: "expenses",
  paymentConsole: "payment-console",

  admissionsPipeline: "admissions-pipeline",
  admissionsPipelineSettings: "admissions-pipeline-settings",
  seatAvailability: "seat-availability",
  studentSearch: "student-search",
  enrollmentView: "enrollment-view",
  dataIngestion: "data-ingestion",
  enquiryIngestion: "enquiry-ingestion",
  scormCourses: "scorm-courses",
  compliance: "compliance",
  studentPhotoUpload: "student-photo-upload",
  uploadedDocsLog: "uploaded-docs-log",
  personalizedDocuments: "personalized-documents",

  directorDashboard: "director-dashboard",
  directorDashboardPrograms: "director-dashboard-programs",
  academicDashboard: "academic-dashboard",
  executiveDashboard: "executive-dashboard",
  executiveFlipDashboard: "executive-flip-dashboard",
  execFlip: "exec-flip",
  voilaBoard: "voila-board",
  instructorBatches: "instructor-batches",
  myTeachingPlan: "my-teaching-plan",

  teacherSchedule: "teacher-schedule",
  substitutionRequests: "substitution-requests",
  postboxMessages: "postbox-messages",
  manualSchedulingBoard: "manual-scheduling-board",
  templateSchedulingBoard: "template-scheduling-board",
  schedulesTemplates: "schedules-templates",
  schedules: "schedules",
  displayBoard: "display-board",
  lcsAccessRequests: "lcs-access-requests",
  approveModules: "approve-modules",

  rubricEvaluation: "rubric-evaluation",
  aiGradingStudio: "ai-grading-studio",
  rubrics: "rubrics",
  dvsEvaluation: "dvs-evaluation",
  omrEvaluation: "omr-evaluation",
  proctoringCenter: "proctoring-center",
  proctoringMonitor: "proctoring-monitor",
  proctoringReview: "proctoring-review",
  gradeCardTemplates: "grade-card-templates",
  gradeCardEntry: "grade-card-entry",
  testDataEntryReporting: "test-data-entry-reporting",

  questionBank: "question-bank",
  tagHierarchyQuestion: "tag-hierarchy-question",
  tagHierarchySchool: "tag-hierarchy-school",
  tagHierarchyTopic: "tag-hierarchy-topic",
  tagHierarchyBatch: "tag-hierarchy-batch",
  assignments: "assignments",
  studyResources: "study-resources",
  decisionResourceStudio: "decision-resource-studio",
  clinicalDomains: "clinical-domains",
  myResources: "my-resources",
  photoGallery: "photo-gallery",

  researchManagement: "research-management",
  mentees: "mentees",

  studentAffairs: "student-affairs",

  campaigns: "campaigns",
  emailTemplates: "email-templates",
  followups: "followups",

  placementEvents: "placement-events",
  placementStudentPlacements: "placement-student-placements",
  placementReports: "placement-reports",

  aiWorkspace: "ai-workspace",
  aiUsageDashboard: "ai-usage-dashboard",
  aiSubscriptions: "ai-subscriptions",
  doubtsDashboard: "doubts-dashboard",
  volunteerWorkspace: "volunteer-workspace",
  counselorWorkspace: "counselor-workspace",
  knowledgeCore: "knowledge-core",
  volunteerVerification: "volunteer-verification",
  atlasInquiries: "atlas-inquiries",
  atlasUsage: "atlas-usage",
  discussionBoard: "discussion-board",
  providerConsole: "provider-console",
  gridReport: "grid-report",
  pathwayAnalytics: "pathway-analytics",
  playgroundUsage: "playground-usage",
  flows: "flows",
  tde: "tde",
} as const;

export type PageKey = (typeof PAGE_KEYS)[keyof typeof PAGE_KEYS];
